import React, { FC } from 'react';
import styles from './text.module.scss';
import { Hyperlink } from '../../Hyperlink';

type Props = React.HTMLProps<HTMLAnchorElement>;

export const TruncatedDefinitionLink: FC<Props> = ({
  children,
  target,
  ...rest
}) => {
  const linkProps = {
    target,
    ...rest,
  };

  return (
    <Hyperlink {...linkProps} className={styles.link}>
      {children}
      {target === '_blank' && (
        <i className="material-icons icons__open_in_new" />
      )}
    </Hyperlink>
  );
};
